"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttributeLogProcessor = void 0;
class AttributeLogProcessor {
    constructor(attributes) {
        this._attributes = attributes;
    }
    // Override onEmit to apply log record attributes before exporting
    onEmit(record) {
        const attributes = record.attributes || (record.attributes = {});
        Object.assign(attributes, this._attributes);
    }
    shutdown() {
        return Promise.resolve();
    }
    forceFlush() {
        return Promise.resolve();
    }
}
exports.AttributeLogProcessor = AttributeLogProcessor;
//# sourceMappingURL=attributeLogRecordProcessor.js.map